import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { mockAdminUser, mockEmprendedorUser } from '../data/mockData';

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleAdminLogin = () => {
    login(mockAdminUser);
    navigate('/dashboard-admin');
  };

  const handleEmprendedorLogin = () => {
    login(mockEmprendedorUser);
    navigate('/dashboard-emprendedor');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-primary-100 flex items-center justify-center px-4 py-12">
      <div className="max-w-4xl w-full">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-block bg-gradient-to-r from-primary-600 to-primary-700 text-white rounded-2xl px-8 py-4 mb-6 shadow-lg">
            <h1 className="text-4xl md:text-5xl font-bold">Zonna IN</h1>
          </div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Conectando emprendedores con las mejores oportunidades de ferias y eventos
          </p>
        </div>

        {/* Login Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {/* Admin Login */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-100 hover:border-primary-300 transition-all hover:shadow-2xl">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full mb-4 shadow-lg">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Administrador</h2>
              <p className="text-gray-600 text-sm">Gestiona eventos y emprendedores</p>
            </div>

            <div className="bg-gray-50 rounded-xl p-4 mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-purple-400 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  WS
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Wilson Sierra</p>
                  <p className="text-sm text-gray-500">wilson@zonnain.com</p>
                </div>
              </div>
            </div>

            <button
              onClick={handleAdminLogin}
              className="w-full bg-gradient-to-r from-purple-500 to-purple-600 text-white py-4 rounded-xl font-semibold hover:from-purple-600 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Ingresar como Administrador
            </button>
          </div>

          {/* Emprendedor Login */}
          <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-100 hover:border-primary-300 transition-all hover:shadow-2xl">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-600 rounded-full mb-4 shadow-lg">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Emprendedor</h2>
              <p className="text-gray-600 text-sm">Encuentra y reserva tu espacio</p>
            </div>

            <div className="bg-gray-50 rounded-xl p-4 mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-pink-400 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-lg">
                  AG
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Ana Gómez</p>
                  <p className="text-sm text-gray-500">Kreativa Manualidades</p>
                </div>
              </div>
            </div>

            <button
              onClick={handleEmprendedorLogin}
              className="w-full bg-gradient-to-r from-primary-500 to-primary-600 text-white py-4 rounded-xl font-semibold hover:from-primary-600 hover:to-primary-700 transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Ingresar como Emprendedor
            </button>
          </div>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500">
            🎯 Prototipo de demostración - No requiere credenciales reales
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
